import React, { useState, useEffect } from 'react'
import { Tooltip } from '@ow/comps'
import { useFetchRemoteData, useProjectStore } from '@vt/hooks'
import { IconMaps } from '@ow/icons'

const RenderAccountTypeIcon = function ({ isPublic }) {
  return (
    <IconMaps
      width={14}
      height={14}
      size={16}
      type={isPublic ? 'authPublicIcon' : 'authPrivateIcon'}
    />
  )
}

const Author = function ({ detailData }) {
  const fetchRemoteData = useFetchRemoteData()
  const [userInfo, setUserInfo] = useState({})
  const getVtProject = useProjectStore((state) => state.getVtProject)
  const { customInfo } = getVtProject()

  useEffect(() => {
    ;(async () => {
      if (detailData && detailData.username) {
        // 用户详情表
        const userDetail = fetchRemoteData(customInfo.userDetailTbId)
        // 用户表
        const user = fetchRemoteData(customInfo.userTbId)
        // 先查询用户详情表
        const userDetailDatas = await userDetail.fetchTbData({
          filters: {
            queries: [
              {
                slug: 'username',
                queryType: 'containString',
                value: detailData.username,
              },
              {
                slug: 'type',
                queryType: 'containString',
                value: 'twitter',
              },
            ],
            logicType: 'and',
          },
        })
        // 再查用户表
        const userDatas = await user.fetchTbData({
          filters: {
            queries: [
              {
                slug: 'objectId',
                queryType: 'equal',
                value: detailData.username,
              },
            ],
            logicType: 'and',
          },
        })
        const userData = userDatas[0]
        setUserInfo({
          ...userDetailDatas[0],
          isOfficial: detailData.official, // 是否为官方账号
          nickName: userData.username,
          userDesc: `${userData.position || '-'} / ${
            userData.partisan || '-'
          } / ${userData.classification || '-'}`,
        })
      }
    })()
  }, [detailData])

  const transformCount = (count) => {
    const minUnit = 10000
    if (count >= minUnit) {
      return `${(count / minUnit).toFixed(1)}w`
    }
    return count || 0
  }

  return (
    <div className="user-box">
      <div className="header-info">
        {userInfo.avatar && (
          <img
            src={
              userInfo.avatar && userInfo.avatar[0] && userInfo.avatar[0].src
            }
            alt=""
          />
        )}
        {!userInfo.avatar && (
          <div
            style={{
              borderRadius: '50%',
              width: '60px',
              height: '60px',
              overflow: 'hidden',
            }}
          >
            <IconMaps
              size={60}
              width={60}
              height={60}
              type="defaultAvatarIcon"
            />
          </div>
        )}

        <p className="nick-name">{userInfo.nickName}</p>
        <div className="flex items-center">
          {console.log(detailData, userInfo, 'html')}
          <p className="author-name">
            {detailData.official ? userInfo.official : userInfo.unofficial}
          </p>
          <Tooltip
            trigger={
              <span>
                <RenderAccountTypeIcon isPublic={detailData.official} />
              </span>
            }
            position="bottom"
            on={['hover']}
            arrow="top"
            style={{
              background: 'white',
              color: 'rgba(0,0,0,.9)',
              width: 'auto',
              opacity: 1,
              padding: '4px 14px 4px 6px',
              boxShadow:
                '0 5px 5px -3px rgba(0,0,0,0.10), 0 -8px 10px 1px rgba(0,0,0,0.06), 0 3px 14px 2px rgba(0,0,0,0.05)',
            }}
            arrowStyle={{ color: 'white' }}
          >
            <span className="flex items-center">
              <RenderAccountTypeIcon isPublic={detailData.official} />
              <span>{detailData.official ? '官方账号' : '私人账号'}</span>
            </span>
          </Tooltip>
        </div>
        <div className="author-desc">{userInfo.userDesc}</div>
      </div>
      <div className="bottom-info">
        <div>
          <p className="number">{transformCount(userInfo.listed_count)}</p>
          <p className="text">文章</p>
        </div>
        <div>
          <p className="number">{transformCount(userInfo.favourites_count)}</p>
          <p className="text">关注</p>
        </div>
        <div>
          <p className="number">{transformCount(userInfo.followers_count)}</p>
          <p className="text">粉丝</p>
        </div>
      </div>
    </div>
  )
}
export default Author
